var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-page"},[_c('v-container',{attrs:{"fluid":""}},[(_vm.showCallCenterFilials)?_c('use-call-centers-filials-list'):_c('orders-and-couriers-map')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }